import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./slices/user";
import transactionReducer from "./slices/transaction";

export const store = configureStore({
  reducer: {
    user: userReducer.reducer,
    transaction: transactionReducer.reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
